import { AxiosResponse } from 'axios';
import { StorefrontClient } from '../../clients';

export const getPetitionPledgeCountByExternalProductID = async (
  externalProductID: string,
): Promise<AxiosResponse<number>> =>
  StorefrontClient.get<number>(`/orders/petitions/${externalProductID}/pledges/count`).catch((err: RequestError) =>
    Promise.reject(err.response.data.message),
  );
